// extracted by mini-css-extract-plugin
module.exports = {"locl-radio-group":"radio-group_locl-radio-group__eSu_m","locl-radio":"radio-group_locl-radio__EVQOq"};